import React from "react";
import Seo from "components/Seo";
import TransportLayout from "./transportLayout";
import Client from "../../../common/-pages/transport/client";

const MorningClient = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="주요 Cient 현황" />
            <TransportLayout>
                <Client type="morning" />
            </TransportLayout>
        </React.Fragment>
    );
};

export default MorningClient;
